const icon = require('vue-svgicon');
icon.register({
    'lock': {
        width: 20,
        height: 20,
        viewBox: '0 0 20 20',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2.778 16.667c0 1.227.995 2.222 2.222 2.222h10a2.222 2.222 0 002.222-2.222V10A2.222 2.222 0 0015 7.778V6.11a5 5 0 00-10 0v1.666A2.223 2.223 0 002.778 10v6.667zM10 2.222a3.89 3.89 0 013.889 3.89v1.665H6.112V6.111a3.89 3.89 0 013.889-3.889zM16.111 10c0-.614-.498-1.112-1.111-1.112H5c-.614 0-1.111.498-1.111 1.112v6.667c0 .612.497 1.11 1.11 1.11h10c.614 0 1.112-.498 1.112-1.11V10zm-6.666 5a.556.556 0 001.11 0v-3.334a.556.556 0 10-1.11 0V15z" _fill="#9C9BA9"/>`,
    },
});
